module.exports = __webpack_public_path__ + "img/03.ca34363e.jpg";